import { SocketActionController } from '../../shared/scripts/socket/SocketActionController.ts';
import { SocketLobbySend } from '../../shared/scripts/socket/SocketLobbySend.ts';
import { Scene } from './ui_html/UISceneTypes.ts';
import { UIUrlController } from '../../shared/scripts/ui_html/UIUrlController.ts';
import { UIPopupFunnelIncentiveController } from './ui_popup/UIPopupFunnelIncentiveController.ts';
import { UIRoomController } from './ui_html/room/UIRoomController.ts';
import { showMatchmakingErrorPopup } from '../../shared/scripts/matchmaking/MatchmakingUtilsClient.ts';
export class SocketWebActionController extends SocketActionController {
    // eslint-disable-next-line class-methods-use-this
    onChatText(chatData) {
        return;
    }
    onStateSessionState() {
        var _this_uiManager;
        var _this_uiManager_adController_adblockState_isAdblockActive;
        const isAdblockActive = (_this_uiManager_adController_adblockState_isAdblockActive = (_this_uiManager = this.uiManager) === null || _this_uiManager === void 0 ? void 0 : _this_uiManager.adController.adblockState.isAdblockActive) !== null && _this_uiManager_adController_adblockState_isAdblockActive !== void 0 ? _this_uiManager_adController_adblockState_isAdblockActive : false;
        SocketLobbySend.setAdBlockStatusToUserSession(isAdblockActive);
        const accessGameFromLink = UIUrlController.getRoomIdFromUrl() !== undefined;
        if (!this.hasDisplayedLoginIncentive) UIPopupFunnelIncentiveController.showPopup(accessGameFromLink);
        this.hasDisplayedLoginIncentive = true;
    }
    onConnectionEstablished(data) {
        var _this_uiManager;
        (_this_uiManager = this.uiManager) === null || _this_uiManager === void 0 ? void 0 : _this_uiManager.sceneController.loadScene(Scene.Game);
        UIRoomController.updateURLToRoom(data.gameSettingId);
    }
    onStateInitialPlacement() {
        var _this_uiManager;
        (_this_uiManager = this.uiManager) === null || _this_uiManager === void 0 ? void 0 : _this_uiManager.sceneController.loadScene(Scene.Game);
    }
    onMatchmakingUpdate(matchmakingStatusUpdate) {
        var _this_uiManager;
        (_this_uiManager = this.uiManager) === null || _this_uiManager === void 0 ? void 0 : _this_uiManager.matchmakingController.updateMatchmakingStatus(matchmakingStatusUpdate);
    }
    onMatchmakingError(error) {
        var _this_uiManager;
        (_this_uiManager = this.uiManager) === null || _this_uiManager === void 0 ? void 0 : _this_uiManager.matchmakingController.removePopups();
        showMatchmakingErrorPopup(error);
    }
    // eslint-disable-next-line class-methods-use-this
    onChannelRoomUpdate(roomData) {
        return;
    }
    onRoomListUpdate(data) {
        var _this_uiManager;
        (_this_uiManager = this.uiManager) === null || _this_uiManager === void 0 ? void 0 : _this_uiManager.lobby.updateRoomList(data);
    }
    onEndGameText(data) {
        var _this_uiGameManager;
        const playersJoinedRematch = data;
        (_this_uiGameManager = this.uiGameManager) === null || _this_uiGameManager === void 0 ? void 0 : _this_uiGameManager.gameStore.getState().gameEnd.setNumberOfPlayersJoinedRematch(playersJoinedRematch);
    }
    constructor(uiGameManager, uiManager, generalServicesController){
        super(generalServicesController), this.hasDisplayedLoginIncentive = false;
        this.uiGameManager = uiGameManager;
        this.uiManager = uiManager;
    }
}
